import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

type FormGridProps = {
  readonly children: ReactNode;
  readonly className?: string;
};

export function FormGrid({ children, className }: FormGridProps) {
  return <div className={cn('grid grid-cols-2 gap-x-3 gap-y-4 *:min-w-0', className)}>{children}</div>;
}
